import { useEffect, useState } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { setFormData, getFormField } from "@fas/ui-framework";
import { getModalFlags } from "../../services/deprecatedApi";

export type UseModalSwitchHook = {
  name: string;
};

function useOpen(list: string[]): string {
  const opens = useSelector((state) =>
    list.map((k) => getFormField<boolean | undefined>(state, k, "open"))
  );
  const openIndex = opens.findIndex((open) => !!open);
  return list[openIndex] || "";
}

export const useModalSwitch: () => UseModalSwitchHook = () => {
  const [keys, setKeys] = useState<string[]>([]);
  const dispatch = useDispatch();
  useEffect(() => {
    getModalFlags().then((modals: Record<string, boolean>) => {
      const modalKeys: string[] = Object.keys(modals);
      batch(() => {
        modalKeys.forEach((modalKey: string): any =>
          dispatch(
            setFormData(modalKey, {
              open: modals[modalKey],
            })
          )
        );
      });
      setKeys(modalKeys);
    });
  }, [dispatch]);
  return {
    name: useOpen(keys),
  };
};
